<template>
  <div>
    <div class="review-type-tab" v-if="$route.query.mode === 'review'">
      <p></p>
      <span :class="{ on: _reviewType === 1 }" @click="_reviewType = 1">我的答案</span>
      <span :class="{ on: _reviewType === 2 }" @click="_reviewType = 2">正确答案</span>
    </div>
    <div class="supplement answer-content">
      <div class="des" v-html="des"></div>
      <div class="supplement-content">
        <div class="supplement-content-tabs">
          <p :class="{ active: codeTabIndex === index }" v-for="(item, index) in options" :key="index" @click="codeTabIndex = index">
            {{ item.name }}.{{ item.suffix }}
            <span></span>
          </p>
        </div>
        <div class="supplement-content-code">
          <MonacoEditor :value.sync="options[codeTabIndex].code" :editorConfig="editorConfig" ref="MonacoEditor" />
        </div>
        <div class="supplement-content-note">
          <h4>作答区</h4>
          <Input v-model.trim="value" type="textarea" :disabled="isReview" placeholder="请在这里填写程序运行结果" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MonacoEditor from '@/components/MonacoEditor'
import { Input } from 'view-design'
export default {
  components: {
    MonacoEditor,
    Input
  },
  props: {
    des: {
      type: String,
      default: ''
    },
    answer: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 1-我的答案，2-正确答案
    reviewType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      codeTabIndex: 0, // 当前代码块的下标
      replaceStr: '乄', // 替换的字符正则表达式，将这个字符换成输入框
      parseResObj: null // 编译结果
    }
  },
  mounted() {
    this.$nextTick(() => {
      // 修改a标签的数据
      const domA = document.querySelectorAll('.supplement .des a')
      domA.forEach(item => {
        if (item.getAttribute('href').indexOf('http') !== 0) {
          item.setAttribute('href', '/' + item.getAttribute('href'))
        }
        console.log(item.getAttribute('href'))
      })
      // 修改img标签的数据
      const domImg = document.querySelectorAll('.supplement .des img')
      domImg.forEach(item => {
        if (item.getAttribute('src').indexOf('http') !== 0) {
          item.setAttribute('src', '/' + item.getAttribute('src'))
        }
      })
    })
  },
  computed: {
    value: {
      get() {
        return this.answer
      },
      set(val) {
        // 当不是回顾试卷的时候才更新值
        if (this.$route.query.mode !== 'review') {
          this.$emit('update:answer', val)
        }
      }
    },
    // 回顾试卷类型
    _reviewType: {
      get() {
        return this.reviewType
      },
      set(val) {
        this.$emit('update:reviewType', val)
      }
    },
    // 是否是回顾试卷
    isReview() {
      return this.$route.query.mode === 'review'
    },
    editorConfig() {
      const obj = {
        language: this.options[this.codeTabIndex].language,
        otherOptions: { readOnly: true }
      }
      return obj
    }
  }
}
</script>

<style lang="scss" scoped>
.supplement {
  display: flex;
  height: 560px !important;
  // height: 100%;
  // min-height: 300px;
  .des {
    width: 30%;
    height: 100%;
    background-color: #343d45;
    color: #fff;
    padding: 10px 20px;
    overflow-y: auto;
    border-right: 1px solid #1e1e1e;
    line-height: 20px;
  }
  &-content {
    width: 70%;
    height: 100%;
    &-note {
      height: 100px;
      background-color: #343d45;
      padding: 10px;
      color: #fff;
      line-height: 25px;
      overflow-y: auto;
      font-size: 13px;
    }
    &-code {
      height: calc(100% - 140px);
    }
    &-tabs {
      width: 100%;
      height: 40px;
      line-height: 40px;
      background-color: #343d45;
      display: flex;
      justify-content: flex-start;
      & > p {
        padding: 0 30px;
        color: #999999;
        cursor: pointer;
        font-size: 16px;
        position: relative;
        &:hover {
          background: rgba(0, 0, 0, 0.3);
        }
        span {
          display: none;
          width: 30px;
          height: 2px;
          background: #d8d8d8;
          position: absolute;
          left: 50%;
          margin-left: -15px;
          bottom: 0;
        }
        &.active {
          span {
            display: block;
          }
          color: #ffffff;
        }
      }
    }
  }
}
</style>
